import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Space } from '../../Space/src/Space.js';
import modules_0b64ef5e from '../styles/Sheet.module.less.js';

/**
 * @description Sheet Header component.
 *
 * @component
 * @example
 * ```jsx
 * <Sheet.Header>content</Sheet>
 * ```
 */
const Header = React.forwardRef((props, ref) => {
    const { title, subtitle, className, children, ...restProps } = props;
    const cx = useStyles(modules_0b64ef5e);
    return (React.createElement("div", { ref: ref, className: cx(className, 'header'), ...restProps },
        title || subtitle ? (React.createElement(Space, { direction: "vertical", size: 0, className: cx('title-wrapper') },
            title && React.createElement("div", { className: cx('title') }, title),
            subtitle && React.createElement("div", { className: cx('subtitle') }, subtitle))) : null,
        children));
});
Header.defaultProps = {};
Header.displayName = 'Header';

export { Header };
//# sourceMappingURL=Header.js.map
